import { useQuery } from '@tanstack/react-query';
import { getExecutionDetails, type ExecutionDetailsPayload } from '../../../services/executionService';
import { executionKeys } from '../keys';

export function useExecutionDetails(organizationId?: string, executionId?: string) {
  const queryKey = organizationId && executionId
    ? executionKeys.detail(organizationId, executionId)
    : executionKeys.all(organizationId);

  const query = useQuery<ExecutionDetailsPayload, Error>({
    queryKey,
    enabled: Boolean(organizationId && executionId),
    staleTime: 15_000,
    queryFn: () =>
      getExecutionDetails({
        organizationId: organizationId!,
        executionId: executionId!,
      }),
  });

  return {
    data: query.data,
    isLoading: query.isPending,
    isFetching: query.isFetching,
    error: query.error ?? null,
    refetch: query.refetch,
  };
}
